<template>
  <div class="loading-page">
    <div class="loading-page-image-container" v-if="showImage && image">
      <img :src="mixinGetFilePath(image, 'O')" />
    </div>

    <div class="h4 loading-page-message">
      <div class="title">Smarter Products</div>
      <br />
      <div class="powered">Powered by TradeWindow</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import gsap from 'gsap';

export default {
  data() {
    return {
      showImage: false,
    };
  },
  mounted() {
    gsap
      .timeline({ repeat: -1 })
      .to('#box1', { duration: 0.3, y: 33, ease: 'none' })
      .to('#box2', { duration: 0.3, y: 33, ease: 'none' }, '<')
      .to('#box2', { duration: 0.3, x: 33, ease: 'none' })
      .to('#box2', { duration: 0.3, y: 0, ease: 'none' })
      .to('#box3', { duration: 0.3, y: -33, ease: 'none' }, '<')
      .to('#box3', { duration: 0.3, x: 33, ease: 'none' })
      .to('#box3', { duration: 0.3, y: 0, ease: 'none' })
      .to('#box4', { duration: 0.3, y: 33, ease: 'none' }, '<')
      .to('#box4', { duration: 0.3, x: 33, ease: 'none' })
      .to('#box4', { duration: 0.3, y: 0, ease: 'none' })
      .to('#box5', { duration: 0.3, y: -33, ease: 'none' }, '<')
      .to('#box5', { duration: 0.3, x: -33, ease: 'none' })
      .to('#box5', { duration: 0.3, y: 0, ease: 'none' })
      .to('#box3', { duration: 0.3, y: 33, ease: 'none' }, '<')
      .to('#box3', { duration: 0.3, x: 0, ease: 'none' })
      .to('#box3', { duration: 0.3, y: 0, ease: 'none' })
      .to('#box2', { duration: 0.3, y: -33, ease: 'none' }, '<')
      .to('#box2', { duration: 0.3, x: 0, ease: 'none' });
    setTimeout(() => {
      this.showImage = true;
    }, 2000);
  },
  computed: {
    ...mapGetters({
      image: 'core/loadingImage',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/generic/_loading.scss';
</style>
